<template>
    <div class="row">
        <div class="col-12">
            <card>
                <div class="card-body">
                    <v-server-table
                        ref="vuetable"
                        url="/dtable/assessments"
                        :columns="columns"
                        :options="options"
                    >
                        <template slot="beforeFilter">
                            <h2>
                                <i class="fas fa-file-alt text-primary"></i> {{$t('assessments.title')}}
                            </h2>
                        </template>
                        <template slot="afterLimit" v-if="isAdmin">
                            <router-link class="btn btn-primary ml-2" :to="{ name: 'assessments_new' }">
                                <i class="fas fa-plus fa-fw"></i> {{$t('assessments.button.addnew')}}
                            </router-link>
                        </template>
                        <template slot="status" slot-scope="props">
                            <span
                                class="badge badge-warning text-white"
                                v-if="isOpened(props.row.start_date, props.row.end_date) && !isAnswered(props.row.id)"
                            >Ativo</span>
                            <span
                                class="badge badge-success text-white"
                                v-if="isAnswered(props.row.id)"
                            >Respondido</span>
                            <span
                                class="badge badge-primary"
                                v-if="isEnded(props.row.end_date)"
                            >Encerrado</span>
                            <span
                                class="badge badge-dark"
                                v-if="!isEnded(props.row.end_date) && !isOpened(props.row.start_date, props.row.end_date)"
                            >Não iniciado</span>
                        </template>
                        <template slot="id" slot-scope="props" class="btn-group" role="group">
                          <router-link
                                class="btn btn-xs btn-primary mr-1"
                                title="Responder"
                                :to="{ name: 'assessments_answer', params: { id: props.row.id } }"
                                v-if="!isEnded(props.row.end_date) && isOpened(props.row.start_date, props.row.end_date) && !isAnswered(props.row.id) && !isAdmin"
                            >
                                <i class="fas fa-tasks fa-fw"></i>
                            </router-link>
                            <a
                                class="btn btn-xs btn-primary mr-1 text-white"
                                title="Exportar respostas"
                                @click="exportAnswers(props.row.id, props.row.title, props.row.start_date, props.row.end_date)"
                                v-if="isAdmin && props.row.answers_count > 0"
                            >
                                <i class="fas fa-poll fa-fw"></i>
                            </a>
                            <router-link
                                class="btn btn-xs btn-primary mr-1"
                                title="Editar"
                                :to="{ name: 'assessments_edit', params: { id: props.row.id } }"
                                v-if="isAdmin"
                            >
                                <i class="fas fa-edit fa-fw"></i>
                            </router-link>
                            <router-link
                                class="btn btn-xs btn-primary mr-1"
                                title="Apagar"
                                :to="{ name: 'assessments_delete', params: { id: props.row.id } }"
                                v-if="isAdmin"
                            >
                                <i class="fas fa-trash-alt fa-fw"></i>
                            </router-link>
                        </template>
                    </v-server-table>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import $http from "@/helpers/api";

export default {
  data() {
    return {
      columns: ["title", "description", "start_date", "end_date", "answers_count", "status", "id"],
      options: {
        visibleColumns: ["title", "description", "start_date", "end_date", "status", "id"],
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          title: () => this.$t('field.title'),
          description: () => this.$t('field.description'),
          start_date: () => this.$t('field.start_date'),
          end_date: () => this.$t('field.end_date'),
          created_at: () => this.$t('field.createdat'),
          status: () => this.$t('field.status'),
          answers_count: () => this.$t('field.answers'),
          id: ""
        },
        texts: {
          count: this.$t('field.count'),
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
          limit: this.$t('field.limit'),
        },
        orderBy: {
          ascending: false,
          column: "title"
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        params: {
          
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      },
      asf_id: this.$store.getters["auth/getCurrentAsf"],
      assessments_ids: []
    };
  },
  computed: {
    ...mapState("assessments", {
      answers: "answers"
    }),
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    },
   
  },
  created() {
    if(this.isAdmin){
      this.options.visibleColumns = ["title", "start_date", "end_date", "answers_count", "status", "id"];
    }

    if(this.isAdmin === false){
      // pega respostas se nao for admin
      this.$store
        .dispatch("assessments/getAnswers", this.asf_id)
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
        
        // console.log(this.answers.length);
    }

    //cria array com os assesment ids
    if(this.answers.length > 0){
      // prepare array with answered asssessments ids
      this.assessments_ids = [];
      this.answers.forEach((item) => {
        this.assessments_ids.push(item.assessment_id);
      });

      // console.log(this.assessments_ids);
    }
  },
  methods: {
    isOpened(startDate, endDate){
      // console.log("isOpened");
      return (
        this.$moment(new Date()).isAfter(startDate) && 
        this.$moment(new Date()).isBefore(endDate)
      );
    },
    isEnded(endDate){
      // console.log("isEnded");
      return this.$moment(new Date()).isAfter(endDate);
    },
    isAnswered(assessment_id){
      if(this.isAdmin === false){
        return this.assessments_ids.includes(assessment_id);
      }
      return false;
    },
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    exportAnswers(assessment_id, title){
      // console.log(this.$refs.vuetable.data);
      let filename = 'AA_' + this.getCurrentDate().replace('-', '').replace('-', '') + '-' + title.replace(/[^A-Z0-9]/ig, "_");
      filename = filename.substring(0, 31); //máximo de 31 caracteres
      this.export2Excel("/answers/export", assessment_id, filename);
    },
    export2Excel(url, assessment_id, filename) {
      $http.get(url+'/'+assessment_id).then(resp => {
        this.exportData = {
          header: resp.data[0],
          data: resp.data.slice(1)
        }

        import('@/excel/Export2Excel').then(excel => {
          const data = this.exportData.data; 

          excel.export_json_to_excel({
            header: this.exportData.header, //Header Required
            data, //Specific data Required
            filename: filename, //Optional
            autoWidth: true, //Optional
            bookType: 'xlsx' //Optional
          })
        })
      });
    }
  }
};
</script>
<style></style>
